import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as gruzovikiApi from "../../utils/api.js"

import ArrowLeftIco from "../../images/ArrowLeftIco.svg"

import OrderCreationFirstStep from "./OrderCreationSteps/OrderCreationFirstStep/OrderCreationFirstStep.jsx";
import OrderCreationSecondStep from "./OrderCreationSteps/OrderCreationSecondStep/OrderCreationSecondStep.jsx";

import InfoPopup from "../InfoPopup/InfoPopup.jsx";

function OrderCreationScreen() {
    const navigate = useNavigate();
    const [page, setPage] = useState(0)
    const token = localStorage.getItem("token")

    const [inputs, setInputs] = useState({
        date: '', // дата перевозки (необходима если в points не будут указаны даты)
        startCity:'', //Начальный город (необходима если маршрутного листа не будет)
        endCity:'', //конечный город (необходима если маршрутного листа не будет)
        vehicleRequirements:'', // Требования к ТС
        weight:0, // Вес груза
        price:0, // цена заказа
        volume:0, // Объем груза
        name:"", // Имя груза
        note:"", // примечание к грузу
        loadingPointsArray:[], //точки погрузки
        unloadingPointsArray:[], //точки разгрузки
        contactName:"", // имя контактного лица (если есть)
        contactNumber:"", // номер телефона контактного лица (если есть)
        specialRequirements:"", // особые требования
        comment:"", // комментарий к заявке
    })
    console.log(inputs)

    const handleCreateApplic = () => {
        gruzovikiApi
            .createApplic(inputs, token)
            .then((res) =>{
                console.log(res.message)
            })
            .catch((err) => {
                console.error(err)
            })
    }

    const [isInfoPopupOpened, setIsInfoPopupOpened] = useState(false)

    const componentsList = [
        <OrderCreationFirstStep page={page} setPage={setPage} inputs={inputs} setInputs={setInputs} />,
        <OrderCreationSecondStep page={page} setPage={setPage} inputs={inputs} setInputs={setInputs} handleCreateApplic={handleCreateApplic} setIsPopupOpened={setIsInfoPopupOpened}/>,
    ]

    return (
        <div className="app app_order-creation">
            <div className="order-creation">
                <InfoPopup
                    show={isInfoPopupOpened}
                    onClose={() => navigate('/home')}
                    title={"Заявка создана!"}
                    mainButtonText={"На главную"}
                    onMainButtonClick={() => navigate('/home')}
                    >
                </InfoPopup>

                <div className="order-creation__steps-container">{componentsList[page]}</div>
                <div className="order-creation__steps-container">{componentsList[1]}</div>

            </div>
        </div>
    )
}

export default OrderCreationScreen